import { createFlagsSchema, schema } from '@funtech-int/yango-shared';

export const remoteConfigSchema = createFlagsSchema({
    branded_selections: schema
        .mapOf(schema.create({ selectionIds: schema.arrayOf(schema.string).optional() }))
        .optional(),
});
